import store from "../../redux/store";
import { setIsLoading } from "../../redux/loader/action";
import {
  setCurrentUser,
  setSliceGameCode,
  show_leave_game
} from "../../redux/game/action";
import { get_route_from_game_code } from "./get_route_from_game_code";

export const handleJoinRoom = (res, history) => {
  const currentUser = store.getStore().getState().gameReducer.currentUser;
  store.dispatch(setIsLoading(false));
  if (res && res.code === 401 && res.error === "Unauthorized - Room is full") {
    window.alert("Warning", "The room you are trying to join is full");
    store.dispatch(show_leave_game(true));
  } else if (
    res &&
    res.code === 403 &&
    res.error === "Game must be at status Joining to complete this action."
  ) {
    window.alert("Game has alredy been started");
    store.dispatch(show_leave_game(true));
  } else if (
    res &&
    res.code === 400 &&
    res.error === "Unable to join, game has ended"
  ) {
    window.alert("Unable to join, game has ended");
    store.dispatch(show_leave_game(true));
  } else if (res && res.room) {
    store.dispatch(
      setCurrentUser({ ...currentUser, userName: res.name, userId: res.userId })
    );
    const route = get_route_from_game_code(res.room.game_code);
    if (route == "slice") {
      store.dispatch(setSliceGameCode(res.room.branch_url));
    } else {
      history.replace(route);
    }
  }
};
